import mainCaller from './mainCaller';

// 상품(수강권·이용권) 변경 로그. productType: TICKET | PASS
export const getProductChangeHistory = async (productType, productId, token) => {
  const path = productType === 'PASS' ? 'passes' : 'tickets';
  return await mainCaller(`admin/api/v1/course/${path}/${productId}/change-history`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};
